import * as React from 'react';
import type {
  InventoryImport,
  InventoryImportsResponse,
  InventoryReportType,
} from 'contracts/inventory-2/uploads';
import { applyQueryString, inventory2Api } from 'services';
import { toInventoryUploadError } from './use-upload-inventory-report';

type FetchParams = {
  type?: InventoryReportType;
  limit?: number;
};

export const useFetchInventoryImports = () => {
  const fetchInventoryImports = React.useCallback(async (params?: FetchParams): Promise<InventoryImport[]> => {
    if (!inventory2Api.defaults.baseURL) {
      throw new Error('Serviço de inventory indisponível.');
    }

    const url = applyQueryString('/imports', {
      type: params?.type,
      limit: params?.limit ?? 50,
    });

    try {
      const { data } = await inventory2Api.get<InventoryImportsResponse>(url);
      return data.imports ?? [];
    } catch (error) {
      throw toInventoryUploadError(error);
    }
  }, []);

  return { fetchInventoryImports };
};
